import { Validator } from '@vista-digital/validator';
import { filmTrailerAssetsValidatorSchema } from '../../trailer/types/assets';
/**
 * Default assets for the Film Trailer Button component.
 */
export const defaultFilmTrailerButtonAssets = {
    playTrailerButtonIconName: 'play-circle',
    failedToLoadTrailerIconName: 'generic-error-message'
};
export const filmTrailerButtonAssetsValidatorSchema = Object.assign(Object.assign({}, filmTrailerAssetsValidatorSchema), { playTrailerButtonIconName: Validator.optional(Validator.nonEmptyString) });
export const filmTrailerButtonAssetsValidator = Validator.object(filmTrailerButtonAssetsValidatorSchema);
//# sourceMappingURL=assets.js.map